export enum PlaylistType {
  ARTIST_CATEGORY_PLAYLIST = 'artistCategoryPlaylist',
  ARTIST_TOP_OFFERS = 'artistTopOffers',
  BOOKS_SAME_CATEGORY_SIMILAR_OFFERS = 'booksSameCategorySimilarOffers',
  OTHER_CATEGORIES_SIMILAR_OFFERS = 'otherCategoriesSimilarOffers',
  SAME_ARTIST_PLAYLIST = 'sameArtistPlaylist',
  SAME_CATEGORY_SIMILAR_OFFERS = 'sameCategorySimilarOffers',
  SEARCH_RESULTS = 'searchResults',
  TOP_OFFERS = 'topOffers',
}
